import * as yup from 'yup';

export const badgeResultSchema = yup.object({
  alias: yup.string().required(),
  cat: yup.string().required(),
  title: yup.string().required(),
  value: yup.number().required(),

  subtitle: yup.string().nullable(),
  description: yup.string().nullable(),
  uncheckUrl: yup.string().required(),
  checkUrl: yup.string().required(),
  // animations Lottie, absentes sur certains badges
  hoverUrl: yup.string().nullable(),
  unlockUrl: yup.string().nullable(),
});

export type BadgeResult = yup.InferType<typeof badgeResultSchema>;

export const badgesResultSchema = yup.object({
  badges: yup.array(badgeResultSchema.required()),
});

export type BadgesResult = yup.InferType<typeof badgesResultSchema>;

export const userBadgeResultSchema = yup.object({
  user: yup.string().required(),
  cat: yup.string().required(),
  value: yup.string().required(),
  date: yup.string().required(),
});

export type UserBadgeResult = yup.InferType<typeof userBadgeResultSchema>;

export const userBadgesResultSchema = yup.object({
  badges: yup.array(userBadgeResultSchema.required()),
});

export type UserBadgesResult = yup.InferType<typeof userBadgesResultSchema>;
